/**
 * Toaster — renderiza el stack de toasts activos en bottom-left.
 * Se monta una sola vez en App.tsx (ver useToast).
 */

import { CheckCircle2, XCircle, Info, X } from "lucide-react";
import { useToastStore, type ToastItem } from "../../hooks/useToast";

const ICON = {
    success: CheckCircle2,
    error: XCircle,
    info: Info,
};

const STYLES = {
    success: "bg-emerald-600 text-white",
    error: "bg-red-600 text-white",
    info: "bg-slate-800 text-white",
};

function ToastCard({ toast }: { toast: ToastItem }) {
    const Icon = ICON[toast.type];
    return (
        <div
            className={`flex items-center gap-2.5 px-4 py-3 rounded-xl shadow-lg text-sm font-medium min-w-[220px] max-w-xs animate-fade-in ${STYLES[toast.type]}`}
            role="status"
            aria-live="polite"
        >
            <Icon size={16} className="flex-shrink-0 opacity-90" />
            <span className="flex-1">{toast.message}</span>
        </div>
    );
}

export function Toaster() {
    const toasts = useToastStore();

    if (toasts.length === 0) return null;

    return (
        <div className="fixed bottom-6 left-6 z-[200] flex flex-col gap-2 pointer-events-none">
            {toasts.map((t) => (
                <ToastCard key={t.id} toast={t} />
            ))}
        </div>
    );
}
